module.exports = __webpack_public_path__ + "media/images/application/social_sharing/twitter-0cf2dbd765234b1d3b9cad0e5a02f7c5.png";